
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/contacts",
      function () {
        return require("private-next-pages/[lang]/contacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/contacts"])
      });
    }
  